@if (msg) {
<div>
  <p>Date: {{ msg.date | date : 'short' }}</p>
  <p>
    From:
    <email-contact [contact]="msg.sender"></email-contact>
  </p>
  <p class="recipients-wrapper">
    To:&nbsp;
    <span class="recipients">
      @for (recipient of msg.recipients; track recipient; let i = $index) {
      <span>
        <email-contact [contact]="recipient"></email-contact>@if (i !=
        msg.recipients.length - 1) {
        <span>, </span>
        }
      </span>
      }
    </span>
  </p>
  <p class="subject">Subject: {{ msg.subject }}</p>
  <div>
    @for (attachment of nonInternalAttachments(msg); track attachment) {
    <span class="attachment">
      <a [href]="toAttachmentLink(attachment.id, msg.id)" target="_blank">
        <icon class="paperclip-icon" type="paperclip"></icon>
        {{ attachment.file_name }}
      </a>
    </span>
    }
  </div>
</div>
<div class="msg-content">
  <iframe
    #iframe
    [src]="formattedContent(msg)"
    frameborder="0"
    scrolling="no"
    sandbox="allow-popups allow-same-origin"
  >
  </iframe>
</div>
} @else { @if (!msg) {
<p class="nocontent-wrapper">Please select an item to read</p>
} }
